import { gql } from '../../../../__generated__';

export default gql(`
  mutation EditCharity($input: EditCharityInput!) {
    editCharity(input: $input) {
      id
      event_participant {
        id
        charity {
          id
          title
          logo_url
          description
        }
        enable_company_fundraising_campaign
        company_supporta_campaign {
          ...SupportaCampaignFields
        }
      }
    }
  }
`);
